import es from '../assets/i18n/es.json'
import pt from '../assets/i18n/pt.json'
import VueI18n from 'vue-i18n'
import Vue from 'vue'

Vue.use(VueI18n)

export default new VueI18n({
  locale: localStorage.getItem('bd-kol-lang') || 'es',
  messages: {
    es: es,
    pt: pt
  }
})
